export const HOME_URL = "";
export const PIXIE_SUPPORT_URL = "/support";
export const LOGIN_PAGE_URL = "/user/login";
